import { updatedBySchema, uuidSchema } from "@qivia/schemas-shared";
import { z } from "zod";
import { vehicleTypeSchema } from "../_shared";

export const vehicleDriverUpdatedPayloadSchema = z.object({
  oldDriverUuid: uuidSchema.nullable(),
  newDriverUuid: uuidSchema.nullable(),
  vehicleUuid: uuidSchema,
  vehicleType: vehicleTypeSchema,
  updatedBy: updatedBySchema,
});

export type PayloadForVehicleDriverUpdated = z.infer<
  typeof vehicleDriverUpdatedPayloadSchema
>;
